export default "__VITE_ASSET__DMj4KN2K__"